<!--
 * @Description: 
 * @Author: xiawenlong
 * @Date: 2021-07-13 09:17:17
 * @LastEditors: xiawenlong
 * @LastEditTime: 2026-02-10 08:42:15
-->

<template>
  <div class="Purchasing">
    <div class="title">
      <img src="@/img/datav/title_icon.png" alt="" />
      <span>客户采购额</span>
    </div>
    <div class="content">
      <div class="buyer-list">
        <div
          v-for="(item, index) in data"
          :key="index"
          :class="['buyer-item', { active: index == currentIndex }]"
          @click="selectBuyer(index)"
        >
          <div class="name">{{ item.orgName }}</div>
          <div class="num">
            <span class="amount">{{ item.totalCost }}</span
            ><span class="unit">万元</span>
          </div>
        </div>
      </div>
      <div class="charts">
        <div id="PurchasingChart"></div>
        <div class="center-glow">
          <div class="glow-core"></div>
          <div class="glow-ring-1"></div>
          <div class="glow-ring-2"></div>
          <div class="glow-ring-3"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as echarts from 'echarts'
let myChart
import { buyerMonth } from '@/api/dashboard'
import to from 'await-to'
// 平台配色方案 - 青绿色系渐变 + 跳色
const colorMap = [
  { start: '#03DFFC', end: '#00A8CC' }, // 青色 -> 深青
  { start: '#FFB800', end: '#FF9500' }, // 琥珀金 -> 橙 (跳色)
  { start: '#16CEB9', end: '#0EA5A0' }, // 薄荷绿 -> 深绿
  { start: '#FF6B6B', end: '#EE4444' }, // 珊瑚红 -> 红 (跳色)
  { start: '#22D3EE', end: '#0891B2' }, // 天蓝 -> 深天蓝
  { start: '#A855F7', end: '#7C3AED' }, // 紫罗兰 -> 紫 (跳色)
]
export default {
  data() {
    return {
      totalNum: 0, //饼图数据+颜色
      optionData: [],
      data: [],
      currentIndex: 0,
    }
  },
  async mounted() {
    myChart = echarts.init(document.getElementById('PurchasingChart'))
    myChart.resize()
    window.addEventListener('resize', () => {
      myChart.resize()
    })
    await this.initData()
    setInterval(() => {
      this.initData()
    }, process.env.VUE_APP_LTIME)
    setInterval(() => {
      this.currentIndex++
      if (this.currentIndex >= this.data.length) {
        this.currentIndex = 0
      }
      this.setOption()
      this.scrollToActiveItem()
    }, 4000)
  },
  methods: {
    async initData() {
      const [res, err] = await to(buyerMonth({}))
      if (err) return
      this.data = res.data
      this.setOption()
    },
    selectBuyer(index) {
      this.currentIndex = index
      this.setOption()
      this.scrollToActiveItem()
    },
    scrollToActiveItem() {
      const listEl = document.querySelector('.buyer-list')
      const activeItem = document.querySelectorAll('.buyer-item')[this.currentIndex]
      if (!listEl || !activeItem) return

      const listRect = listEl.getBoundingClientRect()
      const itemRect = activeItem.getBoundingClientRect()
      const itemHeight = itemRect.height
      const listHeight = listRect.height

      // 计算目标滚动位置，让当前项居中显示
      const targetScrollTop =
        listEl.scrollTop + (itemRect.top - listRect.top) - listHeight / 2 + itemHeight / 2

      listEl.scrollTo({
        top: targetScrollTop,
        behavior: 'smooth',
      })
    },
    setOption() {
      if (
        !this.data ||
        !this.data[this.currentIndex] ||
        !this.data[this.currentIndex].productBuyInfoList
      ) {
        return
      }
      const rawData = this.data[this.currentIndex].productBuyInfoList
      // 按采购量排序，让大的在前面
      const sortedData = [...rawData].sort((a, b) => b.purchaseQuantity - a.purchaseQuantity)
      const total = sortedData.reduce((sum, item) => sum + item.purchaseQuantity, 0)

      this.optionData = sortedData.map((item, index) => {
        const colorIdx = index % colorMap.length
        const color = colorMap[colorIdx]
        const percent = ((item.purchaseQuantity / total) * 100).toFixed(1)
        return {
          name: item.typeName,
          value: item.purchaseQuantity,
          percent: percent,
          itemStyle: {
            color: {
              type: 'linear',
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [
                { offset: 0, color: color.start },
                { offset: 1, color: color.end },
              ],
            },
            shadowBlur: 30,
            shadowColor: color.start + '80',
            shadowOffsetY: 10,
          },
          label: {
            color: color.start,
          },
        }
      })

      myChart.clear()
      myChart.setOption({
        tooltip: {
          trigger: 'item',
          backgroundColor: 'rgba(10, 26, 46, 0.95)',
          borderColor: 'rgba(0, 212, 255, 0.3)',
          borderWidth: 1,
          padding: [12, 16],
          textStyle: {
            fontSize: 14,
            color: '#E8F4F8',
            fontFamily: 'Source Han Sans CN',
          },
          formatter: function(params) {
            return `
              <div style="font-weight: bold; margin-bottom: 8px; color: ${params.color}">${params.name}</div>
              <div style="display: flex; justify-content: space-between; gap: 20px;">
                <span>采购量:</span>
                <span style="font-weight: bold;">${params.value}</span>
              </div>
              <div style="display: flex; justify-content: space-between; gap: 20px; margin-top: 4px;">
                <span>占比:</span>
                <span style="font-weight: bold; color: ${params.color}">${params.data.percent}%</span>
              </div>
            `
          },
          extraCssText: 'box-shadow: 0 4px 20px rgba(0, 212, 255, 0.2); border-radius: 8px;',
        },
        legend: {
          show: false,
        },
        series: [
          // 外圈旋转装饰环
          {
            type: 'pie',
            radius: ['68%', '70%'],
            center: ['50%', '50%'],
            silent: true,
            itemStyle: {
              color: 'rgba(0, 212, 255, 0.05)',
            },
            label: { show: false },
            data: [{ value: 1 }],
            animation: true,
            animationDuration: 2000,
            animationEasing: 'linear',
            animationDelay: 0,
          },
          // 外圈装饰环 - 带脉冲效果
          {
            type: 'pie',
            radius: ['65%', '68%'],
            center: ['50%', '50%'],
            silent: true,
            itemStyle: {
              color: {
                type: 'radial',
                x: 0.5,
                y: 0.5,
                r: 0.5,
                colorStops: [
                  { offset: 0, color: 'rgba(0, 212, 255, 0.15)' },
                  { offset: 1, color: 'rgba(0, 212, 255, 0.03)' },
                ],
              },
            },
            label: { show: false },
            data: [{ value: 1 }],
          },
          // 内圈装饰环
          {
            type: 'pie',
            radius: ['28%', '30%'],
            center: ['50%', '50%'],
            silent: true,
            itemStyle: {
              color: 'rgba(0, 212, 255, 0.1)',
            },
            label: { show: false },
            data: [{ value: 1 }],
          },
          // 主玫瑰图
          {
            type: 'pie',
            radius: ['30%', '70%'],
            center: ['50%', '50%'],
            roseType: 'area',
            data: this.optionData,
            // 增强的入场动画 - 加快
            animation: true,
            animationType: 'scale',
            animationEasing: 'elasticOut',
            animationDuration: 1200,
            animationDelay: function(idx) {
              return idx * 80
            },
            animationDurationUpdate: 600,
            animationEasingUpdate: 'cubicInOut',
            // 扇区展开动画
            animationDelayUpdate: function(idx) {
              return idx * 50
            },
            // 选中/悬停效果
            selectedMode: 'single',
            selectedOffset: 15,
            select: {
              itemStyle: {
                shadowBlur: 60,
                shadowColor: 'rgba(0, 212, 255, 1)',
              },
              label: {
                show: true,
                fontSize: 15,
                fontWeight: 'bold',
              },
            },
            emphasis: {
              scale: true,
              scaleSize: 12,
              itemStyle: {
                shadowBlur: 60,
                shadowOffsetX: 0,
                shadowOffsetY: 25,
                shadowColor: 'rgba(0, 212, 255, 0.9)',
              },
              label: {
                show: true,
                fontSize: 14,
                fontWeight: 'bold',
              },
            },
            label: {
              show: true,
              position: 'outside',
              fontSize: 13,
              color: '#E8F4F8',
              fontFamily: 'Source Han Sans CN',
              formatter: function(params) {
                return (
                  '{name|' +
                  params.name +
                  '}\n{value|' +
                  params.value +
                  '} {percent|' +
                  params.data.percent +
                  '%}'
                )
              },
              rich: {
                name: {
                  fontSize: 12,
                  color: '#B8C5D6',
                  padding: [0, 0, 4, 0],
                },
                value: {
                  fontSize: 16,
                  fontWeight: 'bold',
                  color: '#00D4FF',
                },
                percent: {
                  fontSize: 12,
                  color: '#00F5A0',
                },
              },
            },
            labelLine: {
              show: true,
              length: 15,
              length2: 20,
              lineStyle: {
                color: 'rgba(0, 212, 255, 0.5)',
                width: 1,
              },
            },
            itemStyle: {
              borderRadius: 8,
              borderColor: 'transparent',
              borderWidth: 0,
            },
          },
        ],
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.Purchasing {
  position: relative;
  height: 100%;
  box-sizing: border-box;
  padding: 20px 30px;
  .title {
    width: 550px;
    position: relative;
    font-size: 26px;
    color: #ecf8ff;
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    img {
      margin-right: 3px;
    }
  }
  .content {
    width: 100%;
    display: flex;
    .charts {
      position: relative;
      width: 100%;
      height: 380px;
    }
    .badge {
      position: absolute;
      right: 80px;
      top: -55px;
      display: flex;
      align-items: center;
      span {
        font-weight: normal;
        font-size: 21px;
        color: #ecf8ff;
        margin-left: 36px;
      }
    }
    #PurchasingChart {
      position: relative;
      z-index: 99;
      width: 600px;
      height: 380px;
      margin-top: -60px;
      margin-left: auto;
      margin-right: auto;
      overflow: hidden;

      // 添加旋转光环效果 - 缩小尺寸不超出卡片
      &::before {
        content: '';
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 320px;
        height: 320px;
        border-radius: 50%;
        border: 1px dashed rgba(3, 223, 252, 0.15);
        animation: rotate 20s linear infinite;
        pointer-events: none;
        z-index: -1;
      }

      &::after {
        content: '';
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 280px;
        height: 280px;
        border-radius: 50%;
        border: 1px solid rgba(22, 206, 185, 0.1);
        animation: rotateReverse 15s linear infinite;
        pointer-events: none;
        z-index: -1;
      }
    }

    // 中心呼吸灯效果 - 放在 charts 容器下
    .center-glow {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      pointer-events: none;
      z-index: 100;
      width: 100px;
      height: 100px;
      margin-top: -60px;

      .glow-core {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 20px;
        height: 20px;
        border-radius: 50%;
        background: linear-gradient(135deg, #03dffc 0%, #16ceb9 100%);
        box-shadow: 0 0 20px #03dffc, 0 0 40px rgba(3, 223, 252, 0.5),
          0 0 60px rgba(22, 206, 185, 0.3);
        animation: breathe 2s ease-in-out infinite;
      }

      .glow-ring-1 {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 40px;
        height: 40px;
        border-radius: 50%;
        border: 2px solid rgba(3, 223, 252, 0.4);
        box-shadow: 0 0 10px rgba(3, 223, 252, 0.25);
        animation: breathe 2s ease-in-out infinite 0.3s;
      }

      .glow-ring-2 {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 60px;
        height: 60px;
        border-radius: 50%;
        border: 1px solid rgba(0, 224, 219, 0.3);
        box-shadow: 0 0 15px rgba(0, 224, 219, 0.15);
        animation: breathe 2s ease-in-out infinite 0.6s;
      }

      .glow-ring-3 {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 80px;
        height: 80px;
        border-radius: 50%;
        border: 1px solid rgba(22, 206, 185, 0.18);
        box-shadow: 0 0 20px rgba(22, 206, 185, 0.1);
        animation: breathe 2s ease-in-out infinite 0.9s;
      }
    }

    @keyframes rotate {
      from {
        transform: translate(-50%, -50%) rotate(0deg);
      }
      to {
        transform: translate(-50%, -50%) rotate(360deg);
      }
    }

    @keyframes rotateReverse {
      from {
        transform: translate(-50%, -50%) rotate(360deg);
      }
      to {
        transform: translate(-50%, -50%) rotate(0deg);
      }
    }

    @keyframes breathe {
      0%,
      100% {
        opacity: 0.6;
        transform: translate(-50%, -50%) scale(0.9);
      }
      50% {
        opacity: 1;
        transform: translate(-50%, -50%) scale(1.1);
      }
    }
    .chartBottom {
      position: absolute;
      top: 140px;
      left: 42px;
      width: 362px;
      height: 170px;
      background: url('~@/img/datav/pie_bottom.png');
      background-size: 100% 100%;
    }
    .center-animation {
      position: absolute;
      left: 55%;
      top: calc(65% - 60px);
      transform: translate(-50%, -50%);
      width: 100px;
      height: 100px;
      pointer-events: none;
      z-index: 1;

      .ring {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        border-radius: 50%;
        border: 1px solid rgba(0, 212, 255, 0.4);
        box-shadow: 0 0 10px rgba(0, 212, 255, 0.3), inset 0 0 10px rgba(0, 212, 255, 0.1);

        &-1 {
          width: 100px;
          height: 100px;
          animation: ripple 2s ease-out infinite;
        }

        &-2 {
          width: 70px;
          height: 70px;
          animation: ripple 2s ease-out infinite 0.6s;
        }

        &-3 {
          width: 40px;
          height: 40px;
          animation: ripple 2s ease-out infinite 1.2s;
        }
      }

      .core {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 16px;
        height: 16px;
        border-radius: 50%;
        background: radial-gradient(
          circle,
          #00d4ff 0%,
          rgba(0, 212, 255, 0.5) 50%,
          transparent 100%
        );
        box-shadow: 0 0 20px rgba(0, 212, 255, 0.8), 0 0 40px rgba(0, 212, 255, 0.4);
        animation: corePulse 1.5s ease-in-out infinite;
      }
    }

    @keyframes ripple {
      0% {
        transform: translate(-50%, -50%) scale(0.8);
        opacity: 1;
        border-width: 2px;
      }
      100% {
        transform: translate(-50%, -50%) scale(1.5);
        opacity: 0;
        border-width: 0;
      }
    }

    @keyframes corePulse {
      0%,
      100% {
        transform: translate(-50%, -50%) scale(1);
        opacity: 0.8;
        box-shadow: 0 0 20px rgba(0, 212, 255, 0.8), 0 0 40px rgba(0, 212, 255, 0.4);
      }
      50% {
        transform: translate(-50%, -50%) scale(1.2);
        opacity: 1;
        box-shadow: 0 0 30px rgba(0, 212, 255, 1), 0 0 60px rgba(0, 212, 255, 0.6);
      }
    }
  }
  .buyer-list {
    padding-left: 30px;
    height: 320px;
    width: 1300px;
    box-sizing: border-box;
    overflow-x: hidden;
    overflow-y: auto;
    scroll-behavior: smooth;
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
    gap: 14px;
    &::-webkit-scrollbar {
      width: 4px;
    }
    &::-webkit-scrollbar-track {
      background: rgba(0, 212, 255, 0.05);
      border-radius: 2px;
    }
    &::-webkit-scrollbar-thumb {
      background: rgba(0, 212, 255, 0.2);
      border-radius: 2px;
    }
    &::-webkit-scrollbar-thumb:hover {
      background: rgba(0, 212, 255, 0.4);
    }
    .buyer-item {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      width: calc(50% - 7px);
      margin-bottom: 0;
      padding: 14px 16px;
      line-height: 1.4;
      font-size: 16px;
      border-radius: 10px;
      background: linear-gradient(135deg, rgba(0, 212, 255, 0.05) 0%, rgba(0, 100, 150, 0.03) 100%);
      border: 1px solid rgba(0, 212, 255, 0.1);
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      cursor: pointer;
      position: relative;
      overflow: hidden;
      box-sizing: border-box;

      &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        width: 3px;
        height: 100%;
        background: transparent;
        transition: background 0.3s ease;
      }

      &::after {
        content: '';
        position: absolute;
        right: -20px;
        top: -20px;
        width: 60px;
        height: 60px;
        background: radial-gradient(circle, rgba(0, 212, 255, 0.15) 0%, transparent 70%);
        border-radius: 50%;
        opacity: 0;
        transition: opacity 0.3s ease;
      }

      .name {
        width: 100%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        font-weight: 500;
        font-size: 16px;
        color: #a0aec0;
        margin-bottom: 8px;
        transition: all 0.3s ease;
        position: relative;
        z-index: 1;
      }

      .num {
        transition: all 0.3s ease;
        white-space: nowrap;
        position: relative;
        z-index: 1;

        .amount {
          font-size: 22px;
          color: #00d4ff;
          font-weight: 700;
          text-shadow: 0 0 10px rgba(0, 212, 255, 0.3);
        }

        .unit {
          font-size: 12px;
          color: rgba(0, 212, 255, 0.5);
          font-weight: 400;
          margin-left: 2px;
        }
      }

      &:hover {
        background: linear-gradient(
          135deg,
          rgba(0, 212, 255, 0.12) 0%,
          rgba(0, 100, 150, 0.08) 100%
        );
        border-color: rgba(0, 212, 255, 0.25);
        transform: translateY(-3px) scale(1.02);
        box-shadow: 0 8px 24px rgba(0, 212, 255, 0.2);
        &::after {
          opacity: 1;
        }
        .name {
          color: #e2e8f0;
        }
        .num {
          color: #4fd1c5;
          text-shadow: 0 0 15px rgba(79, 209, 197, 0.5);
        }
      }

      &.active {
        background: linear-gradient(
          135deg,
          rgba(0, 212, 255, 0.2) 0%,
          rgba(0, 150, 200, 0.1) 50%,
          rgba(0, 100, 150, 0.05) 100%
        );
        border-color: rgba(0, 212, 255, 0.4);
        box-shadow: 0 0 24px rgba(0, 212, 255, 0.25), inset 0 0 20px rgba(0, 212, 255, 0.05);
        transform: translateY(-2px) scale(1.01);

        &::before {
          background: linear-gradient(180deg, #00d4ff 0%, #00a8cc 100%);
          box-shadow: 0 0 8px rgba(0, 212, 255, 0.6);
        }

        &::after {
          opacity: 0.6;
          background: radial-gradient(circle, rgba(0, 245, 160, 0.2) 0%, transparent 70%);
        }

        .name {
          color: #00d4ff;
          font-weight: 600;
          font-size: 17px;
        }

        .num {
          .amount {
            font-size: 26px;
            color: #00f5a0;
            font-weight: 800;
            text-shadow: 0 0 15px rgba(0, 245, 160, 0.5);
          }

          .unit {
            font-size: 13px;
            color: rgba(0, 245, 160, 0.6);
            font-weight: 400;
          }
        }
      }
    }
  }
}
</style>
